import { render, staticRenderFns } from "./EachCountryTabContent.vue?vue&type=template&id=70bbfae1&scoped=true&"
import script from "./EachCountryTabContent.vue?vue&type=script&lang=js&"
export * from "./EachCountryTabContent.vue?vue&type=script&lang=js&"
import style0 from "./EachCountryTabContent.vue?vue&type=style&index=0&id=70bbfae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bbfae1",
  null
  
)

export default component.exports